export const AccountQueryName = {
  CARD_NUMBER: 'cardnum',
};
export const ADD_APPLIED_COMP_CARD = 'ADD_APPLIED_COMP_CARD';
export const CLEAR_SEARCH_COMP_CARDS = 'CLEAR_SEARCH_COMP_CARDS';
export const DELETE_APPLIED_COMP_CARD = 'DELETE_APPLIED_COMP_CARD';
export const SEARCH_COMP_CARDS = 'SEARCH_COMP_CARDS';
export const SEARCH_COMP_CARDS_FULFILLED = 'SEARCH_COMP_CARDS_FULFILLED';
export const SEARCH_COMP_CARDS_REJECTED = 'SEARCH_COMP_CARDS_REJECTED';
export const SYNC_APPLIED_COMP_CARD = 'SYNC_APPLIED_COMP_CARD';
export const UPDATE_APPLIED_COMP_CARD = 'UPDATE_APPLIED_COMP_CARD';
export const RESET_APPLIED_COMP_CARDS = 'RESET_APPLIED_COMP_CARDS';
